/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect, FC } from 'react'
import { useTranslation } from 'next-i18next'

import ResponsiveImage from '~/components/Image/ResponsiveImage'
import { ButtonPrimary } from '~/components/Buttons/ButtonPrimary'
import { UserLevel } from '~/components/UserLevel/UserLevel'
import { useAppSelector } from '~/redux/hooks'
import { selectBootcampPageLevelProgress } from '~/bootcamp/slices/bootcamp-page.slice'
import QuizResultBadge from '~/bootcamp/components/Quiz/QuizResultBadge'
import QuizResultKudos from '~/bootcamp/components/Quiz/QuizResultKudos'

import { QuizResultProps } from './QuizProps.models'

const mediaQuery = [{ screen: '(min-width: 280px)', width: '360px' }]

const QuizResult: FC<QuizResultProps> = ({
  totalQuestion = 0,
  onQuit,
  correctAnswer = 0,
  badgeImage,
  mathEnergyEarned,
}): React.ReactElement => {
  const { t } = useTranslation(['bootcampQuiz', 'homebase', 'bootcamp'])
  const levelProgress = useAppSelector(selectBootcampPageLevelProgress)
  const [trophyEligible, setTrophyEligible] = useState<boolean>(false)

  useEffect(() => {
    if (!levelProgress) {
      setTrophyEligible(false)
    } else {
      const processedLeafs = levelProgress?.processedLeafs || []
      setTrophyEligible(trophyEligible || !processedLeafs.some((pl: string) => pl.includes('-quiz')))
    }
  }, [levelProgress, trophyEligible])

  return (
    <div className="text-white flex flex-1 flex-col bg-purple-gdark py-6 rounded-b">
      <div className="flex justify-center items-center relative">
        <ResponsiveImage
          alt="victory banner"
          height={330}
          imageWidths="360"
          mediaQuery={mediaQuery}
          srcKey="bootcamp/reward-trumpets.png"
          width={360}
        />
        <div className="absolute flex flex-col justify-center mt-6">
          <QuizResultBadge badgeImage={badgeImage} />
          <span className="text-white text-lg font-bold text-center">{t('bootcampQuiz:victory')}</span>
          <div className="flex items-center justify-center">
            <QuizResultKudos kudosEarned={mathEnergyEarned} />
          </div>
        </div>
      </div>
      <span className="text-center font-semibold text-3xl px-4">
        {t('bootcampQuiz:no_of_correct_answers')} {correctAnswer}/{totalQuestion}
      </span>

      <div className="relative flex-1 flex flex-col justify-between items-center pt-5 pb-5 gap-2 z-20">
        <div className="flex justify-center py-6 mb-2">
          <UserLevel
            dividingLineColor="border-white"
            textSize={{ name: 'text-xl', title: 'text-sm' }}
            xpBarBG="bg-white"
            xpBarColor="bg-green"
          />
        </div>

        <ButtonPrimary className="w-1/4 ring-white text-lg" onClick={onQuit} size="small" type="submit">
          {t('bootcamp:gotoSubjectOverview')}
        </ButtonPrimary>
      </div>
    </div>
  )
}

export default QuizResult
